export default {
    parseMoneyStatistics({ data, grouping, total }) {
        const metrics = ["ar_metric", "cr_metric"];
        const payouts = ["total_payout", "approved_payout", "pending_payout", "rejected_payout"];
        metrics.forEach((metric) => (total[metric] = +(total[metric] * 100).toFixed(2) + "%"));
        payouts.forEach((metric) => (total[metric] = +total[metric].toFixed(2)));

        return { data, grouping, total };
    },
};
